<template>
  <div class="card container" style="border:none; max-width: 900px;">
    <div class="row" v-if="!progress">
      <div class="col-lg-12">
          <div class="card-content">
            <div class="row">
              <div class="col-4 text-lg-left">
                <h3 v-if="ViewRoom || updateRoom">{{ item.room.name?item.room.name:"" }}</h3>
              </div>
              <div class="col-lg-8 text-lg-center"><h6 v-if="ViewRoom">Type : {{ item.roomType.name }}</h6>
              <h3 v-else>{{ item.name }}
              </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 container-fluid">
                    <Multiselect
                      v-if="updateRoom"
                      v-model="item.roomType"
                      selectLabel=""
                      :options="item.room.types"
                      placeholder="Room Type"
                      track-by="name"
                      :customLabel="item => item.name"
                      @input="GetAmenitiesEdit($event, index, item)"
                      ><span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                      >
                      <template slot="singleLabel" slot-scope="{ option }">
                        {{ option.name }}</template
                      >
                    </Multiselect>
                    <Multiselect
                      v-else
                      v-model="item.room_type_id"
                      selectLabel=""
                      :options="item.types"
                      placeholder="Room Type"
                      track-by="name"
                      :customLabel="item => item.room_type.name"
                      @input="GetAmenities($event, index, item)"
                      ><span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                      >
                      <template slot="singleLabel" slot-scope="{ option }">
                        {{ option.room_type.name }}</template
                      >
                    </Multiselect>
              </div>
              <div class="col-lg-12" v-if="updateRoom">
                <div class="msg">
                  <h6>
                    Change Date
                    <input
                      type="checkbox"
                      v-model="changedate"
                      style="width:40px;height:20px"
                      checked="checked"
                    />
                  </h6>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group" v-if="changedate">
                  <DatePicker
                    v-model="Filter.start"
                    @input="setEndDate"
                    placeholder="From Date"
                    :limit="DateLimit"
                  />
                </div>
                <div class="form-group" v-else>
                  <label v-if="ViewRoom" style="margin-left: -200px;"
                    >Check In</label
                  >
                  <input
                    v-if="ViewRoom || updateRoom"
                    class="form-control"
                    v-model="item.check_in"
                    disabled
                  />
                  <input
                    v-else
                    class="form-control"
                    v-model="FilterDate.start"
                    disabled
                  />
                  <!-- <i class="icon_calendar"></i> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group" v-if="changedate">
                  <DatePicker
                    v-model="Filter.end"
                    placeholder="To Date"
                    @input="checkAvailability , checkdataamount()"
                    :limit="EndDateLimit"
                  />
                </div>
                <div v-else class="form-group">
                  <label v-if="ViewRoom" style="margin-left: -200px;"
                    >Check Out</label
                  >
                  <input
                    v-if="ViewRoom || updateRoom"
                    class="form-control"
                    v-model="item.check_out"
                    disabled
                  />
                  <input
                    v-else
                    class="form-control"
                    v-model="FilterDate.end"
                    disabled
                  />
                  <!-- <i class="icon_calendar"></i> -->
                </div>
              </div>
              <div class="col-lg-12" v-if="changedate">
                <label style="color:red" v-if="Roomavailablity"
                  >This Room Available Not For this Date</label
                >
                <label style="color:green" v-else
                  >This Room Available For this Date</label
                >
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label
                    v-if="ViewRoom || updateRoom"
                    style="margin-left: -200px;"
                    >Adults</label
                  >
                  <input
                    v-if="ViewRoom"
                    class="form-control"
                    disabled
                    v-model="item.adults"
                    placeholder="Adults"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                    @input="RefreshAdultsCount($event, index, item)"
                  />
                  <input
                    v-else
                    class="form-control"
                    v-model="item.adults"
                    placeholder="Adults"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                    @input="RefreshAdultsCount($event, index, item)"
                  />
                  <label v-if="item.adults > item.max_adult" style="color: red"
                    >Room have maximum {{ item.max_adult }} Adults
                  </label>
                  <!-- <i class="icon_profile"></i> -->
                </div>
              </div>

              <div class="col-lg-4">
                <div class="form-group">
                  <label
                    v-if="ViewRoom || updateRoom"
                    style="margin-left: -220px;"
                    >Child</label
                  >
                  <input
                    v-if="ViewRoom"
                    class="form-control"
                    disabled
                    v-model="item.child"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                    @input="RefreshChildCount($event, index, item)"
                    placeholder="Child"
                  />
                  <input
                    v-else
                    class="form-control"
                    v-model="item.child"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                    @input="RefreshChildCount($event, index, item)"
                    placeholder="Child"
                  />
                  <label v-if="item.child > item.max_child" style="color: red"
                    >Room have maximum {{ item.max_child }} Childs
                  </label>

                  <!-- <i class="icon_group"></i> -->
                </div>
              </div>

               <div class="col-lg-4">
                <div class="form-group">
                  <label
                    v-if="ViewRoom || updateRoom"
                    style="margin-left: -190px;"
                    >Amount</label
                  >
                  <input
                    v-if="ViewRoom"
                    class="form-control"
                    disabled
                    v-model="item.amount"
                    placeholder="Amount"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                  />
                  <input
                    v-else
                    @input="setTotalAmount($event, index, item)"
                    class="form-control"
                    v-model="item.amount"
                    placeholder="Amount"
                    min="0"
                    type="number"
                    oninput="validity.valid||(value='');"
                  />
                  <label v-if="item.amount < 0" style="color: red"
                    >Please Enter Amount Greater than 0</label
                  >
                </div>
      </div>
              <div class="col-lg-12">
                  <div class="col-lg-12">
                    <label
                      v-if="ViewRoom || updateRoom"
                      style="margin-left: -750px;"
                      >Amenites</label 
                    >
                    <Multiselect
                      v-if="ViewRoom"
                      :disabled="true"
                      v-model="item.amenities"
                      :options="amenities"
                      :multiple="true"
                      @input="setAmendities($event, index)"
                      placeholder="Services"
                      track-by="name"
                      label="name"
                      ><span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                      ></Multiselect
                    >
                    <Multiselect
                      v-else
                      :disabled="loadingAmentidy"
                      v-model="item.amenities"
                      :options="amenities"
                      :multiple="true"
                      @input="setAmendities($event, index)"
                      placeholder="Services"
                      track-by="name"
                      label="name"
                      ><span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                      ></Multiselect
                    >
                  </div>
              </div>
              <div class="col-lg-12" v-if="!ViewRoom">
                <button
                  class="booknow"
                  @click="updateRoomDetails(item.id)"
                  v-if="item.amount && updateRoom"
                >
                  Update now
                </button>
                <button
                  class="booknow"
                  @click="bookRoom(item)"
                  v-if="item.amount && !updateRoom"
                >
                  Book now 
                </button>
                <button
                  class="booknow1"
                  @click="cancel()"
                  v-if="item.amount && !updateRoom"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DatePicker } from "@/components/base/index";
import Courosel from "@/components/base/Caurosel/index";
import Multiselect from "vue-multiselect";
import moment from "moment";
import axios from "@/plugins/axios";
import {} from "@/components/base/index";

export default {
  components: {
    Multiselect,
    Courosel,
    DatePicker
  },
  props: {
    FilterDate: {
      type: Array,
      default: []
    },
    Filter: {
      type: Object,
      default: {}
    },
    RoomImages: {
      type: Array,
      default: []
    },
    item: {
      type: Array,
      default: []
    },
    ReservationId: {
      type: Number,
      default: null
    },
    ViewRoom: {
      type: Boolean,
      default: false
    },
    updateRoom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progress: false,
      changedate: false,

      amenities: [],
      DateLimit: [
        {
          type: "weekday",
          available: [0, 1, 2, 3, 4, 5, 6]
        },
        {
          type: "weekend",
          available: [1, 2]
        },
        {
          type: "fromto",
          from: moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
          // to: '2022-02-15'
        }
      ],
      EndDateLimit: [
        {
          type: "weekday",
          available: [0, 1, 2, 3, 4, 5, 6]
        },
        {
          type: "weekend",
          available: [1, 2]
        },
        {
          type: "fromto",
          from: moment(new Date())
            .subtract(1, "days")
            .format("YYYY-MM-DD")
          // to: '2022-02-15'
        }
      ],

      PaymentTypes: [{ name: "Card" }, { name: "Cash" }],
      roomtypes: [],
      coverImagePreview: [],
      Roomavailablity: false,
      loadingAmentidy: false,
      BookingRoomDetails: {},
      Filter: {
        start: "",
        end: ""
      }
    };
  },

  methods: {
    cancel(){
      this.$store.commit("orders/updateRoomVisible", false);
          this.$router.push(`/reservation-details/` + this.ReservationId);
    },
    //Update Edited Details
    updateRoomDetails(index) {
      let credential = this.item;
      credential.room_id = this.item.room.id;
      credential.room_type_id = this.item.roomType.id;
      if (this.changedate) {
        credential.check_in = this.Filter.start;
        credential.check_out = this.Filter.end;
      } else {
        credential.check_in = this.item.check_in;
        credential.check_out = this.item.check_out;
      }
      if (credential.amenities) {
        credential.amenities = credential.amenities.map(p => {
          return p.id;
        });
      } else {
        credential.amenities = [];
      }
      delete credential.duration;
      delete credential.id;
      delete credential.max_adult;
      delete credential.max_child;
      delete credential.room;
      delete credential.roomType;
      delete credential.totalAmount;
   
      axios
        .patch(
          `hms/web/reservations/${this.ReservationId}/rooms/${index} `,
          credential
        )
        .then(res => {
          
           this.$fire({
            title: "Success",
            text: " Room Updated SuccessFully",
            type: "success",
            timer: 3000,
          }).then((r) => {});
          this.$emit("Afterhide")
        })
        .catch(err => {
            this.$fire({
          title: "Error",
          text: "Room Edit Failed",
          type: "error",
          timer: 3000
        })
        });
    },
    // checking rooms available on booking
    checkAvailability() {
      axios
        .get(
          `hms/web/rooms/1/check-availability?start=${this.Filter.start}&end=${this.Filter.end} `
        )
        .then(res => {
          this.Roomavailablity = res.data.availability;
        })
        .catch(err => {});
    },
    // Set End Date
    setEndDate(startDate) {
    
      startDate = moment(new Date(startDate));
      let Enddate = startDate.add(1, "days");
      Enddate = startDate.format("YYYY-MM-DD");
      this.EndDateLimit[2].from = startDate.subtract(1, "days");
      this.Filter.end = Enddate;
      this.checkAvailability();
    },
    checkdataamount(){
      let startDate = moment(new Date(this.Filter.start));
      let endDate = moment(new Date(this.Filter.end));
       let durations = startDate.diff(endDate, "days");
       let valuechnage =Math.abs(durations)
       this.item.totalAmount = this.item.amount * valuechnage
        this.item.duration = valuechnage
    },
    //Book Room Method
    bookRoom(item) {
   
      this.BookingRoomDetails = item;
      // this.BookingRoomDetails.room_id = item.room_id;
      this.BookingRoomDetails.check_in = this.FilterDate.start;
      this.BookingRoomDetails.check_out = this.FilterDate.end;
      this.BookingRoomDetails.number_of_room = 1;
      this.BookingRoomDetails.room_id = item.id;
      this.BookingRoomDetails.room_type_id = item.room_type_id.room_type.id;

      if (this.BookingRoomDetails.amenities) {
        this.BookingRoomDetails.amenities = this.BookingRoomDetails.amenities.map(
          p => {
            return p.id;
          }
        );
      } else {
        this.BookingRoomDetails.amenities = [];
      }
      delete this.BookingRoomDetails.end;
      delete this.BookingRoomDetails.created_at;
      delete this.BookingRoomDetails.duration;
      delete this.BookingRoomDetails.max_child;
      delete this.BookingRoomDetails.floor;
      delete this.BookingRoomDetails.id;
      delete this.BookingRoomDetails.image;
      delete this.BookingRoomDetails.images;
      delete this.BookingRoomDetails.is_active;
      delete this.BookingRoomDetails.is_smoking;
      delete this.BookingRoomDetails.max_adult;
      delete this.BookingRoomDetails.name;
      delete this.BookingRoomDetails.phone_expression;
      delete this.BookingRoomDetails.reference_number;
      delete this.BookingRoomDetails.remarks;
      delete this.BookingRoomDetails.start;
      delete this.BookingRoomDetails.totalAmount;
      delete this.BookingRoomDetails.types;
      axios
        .post(
          `hms/web/reservations/${this.ReservationId}/rooms `,
          this.BookingRoomDetails
        )
        .then(res => {
          this.$store.commit("orders/updateRoomVisible", false);
          this.$router.push(`/reservation-details/` + this.ReservationId);
        })
        .catch(err => {});
    },
    //refresh Child Count
    RefreshChildCount(event, index, item) {
      this.progress = true;
      item.child = event.target.value;
      this.progress = false;
    },
    //refresh Adult Count
    RefreshAdultsCount(event, index, item) {
      this.progress = true;
      item.adults = event.target.value;
      this.progress = false;
    },

    //refresh Amount
    setTotalAmount(event, index, item) {
      this.progress = true;
      item.amount = event.target.value;

      item.totalAmount = item.amount * item.duration;

      this.progress = false;
    },

    //Get Amenites And other Data for perticular RoomType For edit
    GetAmenitiesEdit(event, index, item) {
  
      if (event) {
        item.amenities = event.amenities;
        item.adults = event.base_adult;
        item.child = event.base_child;
        item.max_adult = event.max_adult;
        item.max_child = event.max_child;
        if (this.Filter.start != "") {
          var a = moment(new Date(this.Filter.end));
          var b = moment(new Date(this.Filter.start));
        } else {
          var a = moment(new Date(item.check_out));
          var b = moment(new Date(item.check_in));
        }

        item.duration = a.diff(b, "days");
        item.amount = event.room_rates.amount;
        item.totalAmount = item.amount * item.duration;
      } else {
        item.amenities = [];
        item.adults = 0;
        item.child = 0;
        item.max_adult = 0;
        item.max_child = 0;

        item.amount = 0;
      }
    },

    //Get Amenites And other Data for perticular RoomType
    GetAmenities(event, index, item) {
      if (event) {
        item.amenities = event.room_type.amenities;
        item.adults = event.room_type.base_adult;
        item.child = event.room_type.base_child;
        item.max_adult = event.room_type.max_adult;
        item.max_child = event.room_type.max_child;

        var a = moment(new Date(this.FilterDate.end));
        var b = moment(new Date(this.FilterDate.start));
        item.duration = a.diff(b, "days");
        item.amount = event.amount;
        item.totalAmount = item.amount * item.duration;
      } else {
        item.amenities = [];
        item.adults = 0;
        item.child = 0;
        item.max_adult = 0;
        item.max_child = 0;

        item.amount = 0;
      }
    }
  }
};
</script>

<style scoped>
.booknow1{
  width: 180px;
  height: 40px;
  border: none;
  background: #e93c3c;
  color: white !important;
}
.booknow {
  width: 180px;
  height: 40px;
  border: none;
  background: #335626;
  color: white !important;
}
.owl-carousel .owl-item img {
  height: 277px !important;
}
.EditButton {
  background-color: #fff;
  border: 1px solid #ededed;
  padding: 5px;
  height: auto;
  color: #999;
  border-radius: 3px;
}
.imgContainer {
  max-width: 960px;
  margin: 10px auto;
  padding: 20px;
}
h1 {
  font-size: 20px;
  text-align: center;
  margin: 20px 0 20px;
}
h1 small {
  display: block;
  font-size: 15px;
  padding-top: 8px;
  color: gray;
}

.msg {
  text-align: end;
}
body {
  background: #eee;
}
btn-outline-primary {
  background-color: #da2845;
}
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn {
  color: #3a3131;
}
.ratings i {
  font-size: 16px;
  color: red;
}

.strike-text {
  color: red;
  text-decoration: line-through;
}

.product-image {
  width: 100%;
}

.dot {
  height: 7px;
  width: 7px;
  margin-left: 6px;
  margin-right: 6px;
  margin-top: 3px;
  background-color: blue;
  border-radius: 50%;
  display: inline-block;
}

.spec-1 {
  color: #938787;
  font-size: 15px;
}

h5 {
  font-weight: 400;
}

.para {
  font-size: 16px;
}

.person {
  width: 120px;
  border: 1px solid;
  height: 40px;
  border-radius: 20px;
}
.imagepic {
  width: 100%;
  height: 250px;
}

.card-content {
  padding: 10px;
}
.countdetails {
  margin-bottom: 10px;
}

.carddesign {
  margin-bottom: 10px;
}

.close {
  position: absolute;
  right: 32px;
  top: 2px;
  width: 20px;
  height: 32px;
  opacity: 0.5;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.btn-circle {
  width: 30px;
  height: 30px;
  content: "X";
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.paragraph {
  height: 70px;
}
</style>
<style>
.datepickbox input {
  width: 100% !important;
  border: 1px solid rgb(218 220 222) !important;
  box-shadow: unset !important;
}
.cov-vue-date {
  width: 100% !important;
}
.multiselect__option {
  width: 100% !important;
  font-size: 14px !important;
}
.box_booking_2 .main ul li span,
.sign_up .main ul li span {
  float: left !important ;
}
.roomamount {
  margin-left: 10px !important;
  margin-bottom: 10px !important;
}
.imageEditBtn {
  background-color: #cccccc !important;
  border: none;
  border-radius: 50%;
  height: 27px;
  width: 27px;
}
.modal.header{
margin-bottom: 10px  !important;

}
.form-control {
}
.error {
  color: #da2845;
}
.cov-vue-date .icon_calendar {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  pointer-events: none;
}
.form-control {
  height: 42px;
  border-radius: 6px;
  border: 1px solid #d1d1d1;
  font-size: 14px;
  padding: 8px 12px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
